import React, { memo } from "react";
import { equals } from "ramda";
import clsx from "clsx";
import { Tooltip } from "@material-ui/core";

import palette from "../../styles/palette";
import { SpotIcon } from "../../icons";

import { HIGH_VALUE_PARCEL, TOTE_PARCEL } from "../../../constants/strings";

export const ServiceItem = memo(
  ({ value }) => {
    const color =
      (!!value?.perishable && palette.statuses.statusBlue) ||
      (!!value?.vipDelivery && palette.dpdRed);

    return (
      <span>
        {color && <SpotIcon color={color} />} {value?.serviceLabel}
      </span>
    );
  },
  (prevProps, nextProps) => equals(prevProps.value, nextProps.value)
);

const Item = ({ classes }) => <div className={clsx(classes)}></div>;

export const HighValueItem = memo(
  ({ rowData, classes }) => {
    const { highValue, smallsToteParcel } = rowData;
    let values = [];
    let tipItems = [];

    if (smallsToteParcel) {
      values.push(
        <Item classes={[classes.cellHighValue, classes.cellOrange]} />
      );
      tipItems.push(TOTE_PARCEL);
    }

    if (highValue) {
      values.push(<Item classes={[classes.cellHighValue, classes.cellBlue]} />);
      tipItems.push(HIGH_VALUE_PARCEL);
    }
    return values.length ? (
      <Tooltip
        title={
          <div style={{ whiteSpace: "pre-line" }}>{tipItems.join("\n")}</div>
        }
        placement="right-start"
        fontSize="small"
      >
        <div className={clsx([classes.fullHeighContainer])}>{values}</div>
      </Tooltip>
    ) : (
      ""
    );
  },
  (prevProps, nextProps) => equals(prevProps.rowData, nextProps.rowData)
);
